
import WDPaneList from './wd-pane-list';
import WDListForm from '../lists/wd-list-form';

export default class WDPaneListForm extends WDPaneList
{

	constructor(cfg)
	{
		super(cfg).classList.add('wd-pane-list-form');
	};

	buildList(cfg)
	{
		this.list = new WDListForm(cfg);

		if (cfg?.filters)
		{
			this.list.filters = this.addFilters({ filters: cfg.filters });
		}

		return this.list;
	};

};

customElements.define('wd-pane-list-form', WDPaneListForm);
